import { FC, useEffect, useReducer, useRef } from "react";

import YesNoInput from "./yesNoInput";
import TextFieldComp from "./textField";
import RadioInputComp from "./radioInput";
import CheckboxInputComp from "./checkboxInput";
import DateFieldComp from "./dateField";
import LabelInputComp from "./labelInput";

import { precertFormReducer } from "./reducer";
import { PrecertCompProps } from "./types";
import { shouldFieldRender } from "src/helpers/precertForm";
import usePrecertComp from "src/hooks/usePrecertComp";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { useNavigate } from "react-router-dom";



const NewPrecertComp: FC<PrecertCompProps> = ({ formFields, caseId, precertsId, formId, insuranceId }): JSX.Element => {
  const { groupedFormFields, updateGroupedFormFields } = usePrecertComp(formFields);
  const precertFormRef = useRef(null);
  const [state, dispatch] = useReducer(precertFormReducer, {});
  const navigate = useNavigate();

  useEffect(() => {
    if (groupedFormFields)
      Object.keys(groupedFormFields).forEach((group) => 
        Object.keys(groupedFormFields[group]).forEach((field) =>
          dispatch({ name: groupedFormFields[group][field].name, value: groupedFormFields[group][field].value })
        )
      )

  }, [groupedFormFields]);




  const { data: precertRes, mutate: submitPrecert } =
    useFetch(APIEndpoints.PRECERT_SUBMIT, {}, { caseId, id: precertsId, insuranceId })

  useEffect(() => {
    if (precertRes)
      navigate('/cases');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [precertRes]);
  
  const precertForm = (commit: string) => {
    if (precertFormRef && precertFormRef.current) {
      if ((precertFormRef.current as any).checkValidity()) {
        const requestBody = {
          commit,
          precert: {
            form_id: formId,
            ...state,
          },
          case_id: caseId,
          id: precertsId,
        }
    
        submitPrecert(requestBody)
      } else {
        (precertFormRef.current as any).reportValidity()
      }
    }
  }

  const updateFieldValue = (value: string, fieldId: number, groupName: string) => {
    dispatch({ name: groupedFormFields[groupName][fieldId].name, value })
    updateGroupedFormFields(shouldFieldRender(groupedFormFields[groupName][fieldId], groupedFormFields, value))
  }


  return (
    <form ref={precertFormRef}>
      {Object.keys(groupedFormFields).map((group: string) => (
        <div className="card my-3" key={group}>
          {group !== "" && (
            <div className="card-header">
              <h4 className="mb-0">{group}</h4>
            </div>
          )}
          <div className="card-body">
            {Object.keys(groupedFormFields[group]).sort((firstFieldkey, secondFieldkey) =>
              (groupedFormFields[group][firstFieldkey].group_order || 0) - 
              (groupedFormFields[group][secondFieldkey].group_order || 0)
            ).map((field) => {
              switch(groupedFormFields[group][field].category) {
                case "YesNo":
                  return <YesNoInput key={groupedFormFields[group][field].id} state={state} {...groupedFormFields[group][field]} updateValue={updateFieldValue} />
                case "Text":
                  return <TextFieldComp key={groupedFormFields[group][field].id} state={state} {...groupedFormFields[group][field]} updateValue={updateFieldValue} />
                case "Date":
                  return <DateFieldComp key={groupedFormFields[group][field].id} state={state} {...groupedFormFields[group][field]} updateValue={updateFieldValue} />
                case "Radio":
                  return <RadioInputComp key={groupedFormFields[group][field].id} state={state} {...groupedFormFields[group][field]} updateValue={updateFieldValue} />
                case "CheckBox":
                  return <CheckboxInputComp key={groupedFormFields[group][field].id} state={state} {...groupedFormFields[group][field]} updateValue={updateFieldValue} />
                case "Label":
                  return <LabelInputComp key={groupedFormFields[group][field].id} {...groupedFormFields[group][field]} />
                default:
                  return <></>
              }
            })}
          </div>
        </div>
      ))}
      <div className="text-end">
        <button
          type="submit" className="btn btn-primary btn-sm rounded-0 mx-1"
          onClick={(e) => {
            e.preventDefault()
            precertForm("save")
          }}
        >
          Save for Later
        </button>
        <button
          className="btn btn-success btn-sm rounded-0" type="submit"
          onClick={(e) => {
            e.preventDefault()
            precertForm("save_and_complete")
          }}
        >
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Fax the completed form to the insurance company. If you've attached clinicals, they will be faxed as well."
          >
            Submit for Insurance
          </span>
        </button>
      </div>
    </form>
  );
};

export default NewPrecertComp;
